import React from 'react';

function formatReleaseDate(value) {
  if (!value) return '';
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

/** Release entries from GET /system/version, newest first as given. */
export default function ReleaseNotesList({ releases }) {
  return (
    <div className="space-y-6">
      {releases.map((release) => (
        <section key={release.version} aria-labelledby={`release-${release.version}`}>
          <h3 id={`release-${release.version}`} className="text-base font-semibold text-slate-900">
            {release.title ? `${release.title} ` : ''}
            <span className="text-sm font-normal text-slate-500">v{release.version}</span>
          </h3>
          {release.release_date && (
            <p className="text-xs text-slate-500">{formatReleaseDate(release.release_date)}</p>
          )}
          {Array.isArray(release.notes) && release.notes.length > 0 && (
            <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-700">
              {release.notes.map((note) => (
                <li key={note}>{note}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
